//@flow
import * as React from 'react';
import AcknowledgeButton from 'app/common/react/components/growth/unauth/signup/AccountRecovery/AcknowledgeButton';
import i18n from 'app/common/lib/i18n';
import Modal from 'app/common/react/ui/Modal';
import ResetPasswordButton from 'app/common/react/components/growth/unauth/signup/AccountRecovery/ResetPasswordButton';
import { FACEBOOK_IDENTIFIER } from 'app/common/react/components/growth/unauth/signup/FacebookConnectButton/FacebookConnectButton';
import { Box, Text } from 'gestalt';

type Props = {|
  email: string,
  loginWith: 'facebook' | 'google',
  onClose: () => void,
  onPasswordResetSent: () => void,
  socialButtons: React.Node,
|};

export default function LoginWithFailedModal({
  email,
  loginWith,
  onClose,
  onPasswordResetSent,
  socialButtons,
}: Props) {
  return (
    <Modal
      accessibilityCloseLabel={i18n._('close', 'accessible label for button to close modal')}
      accessibilityModalLabel={i18n._(
        'No matching account',
        'Modal accessibility label for account recovery',
      )}
      heading={i18n._('Oops! Something went wrong', 'Modal heading')}
      onDismiss={onClose}
      role="alertdialog"
      size="md"
    >
      <Box paddingX={6} marginBottom={4}>
        <Box marginBottom={6}>
          {loginWith === FACEBOOK_IDENTIFIER ? (
            <Text>
              {i18n._(
                'We couldn’t match your Facebook account to any Pinterest account. ' +
                  'Try resetting your password instead.',
                'Notice that no Pinterest account exists for the Facebook account used to attempt login',
              )}
            </Text>
          ) : (
            <Text>
              {i18n._(
                'We couldn’t match your Google account to any Pinterest account. ' +
                  'Try resetting your password instead.',
                'Notice that no Pinterest account exists for the Facebook account used to attempt login',
              )}
            </Text>
          )}
        </Box>
        <ResetPasswordButton email={email} callBack={onPasswordResetSent} />
        <Box marginTop={2}>
          <AcknowledgeButton onClick={onClose} />
        </Box>
      </Box>
    </Modal>
  );
}
